const IconFacebookBlue = () => {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.33398 20.4485V21.2485H10.134H12.2673V29.4305C6.42788 27.7925 2.13398 22.4214 2.13398 16.0375C2.13398 8.36112 8.34837 2.13405 16.0007 2.13405C23.6529 2.13405 29.8673 8.36112 29.8673 16.0375C29.8673 22.9496 24.8417 28.6737 18.2673 29.7555V21.2485H21.8673H22.6673V20.4485V16.0375V15.2375H21.8673H18.2673V13.0968C18.2673 12.728 18.571 12.4264 18.934 12.4264H21.8673H22.6673V11.6264V7.21542V6.41541H21.8673H18.2006C14.9263 6.41541 12.2673 9.08391 12.2673 12.3616V15.2375H10.134H9.33398V16.0375V20.4485Z" fill="#1C225A" stroke="#1C225A" strokeWidth="1.6"/>
        </svg>
    )
}

export default IconFacebookBlue